import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCatalog } from '../context/CatalogContext';
import { ProductRow } from '../components/ProductCard';
import { TypeTheme, type ProductType } from '../lib/types';
import { grad } from '../components/ui';

type Sort = 'popular' | 'rating' | 'priceLow';

export function Category() {
  const { type } = useParams<{ type: string }>();
  const navigate = useNavigate();
  const { categories, getProductsByType } = useCatalog();
  const [sort, setSort] = useState<Sort>('popular');

  const key = type as ProductType;
  const meta = TypeTheme[key];
  const category = categories.find((c) => c.type === key);

  if (!meta || !category) {
    return (
      <div className="col center" style={{ padding: 60, gap: 10 }}>
        <div style={{ fontWeight: 800 }}>Category not found</div>
        <button className="link" style={{ background: 'none', border: 'none' }} onClick={() => navigate('/store')}>Go to store</button>
      </div>
    );
  }

  let items = [...getProductsByType(key)].sort((a, b) => {
    if (sort === 'priceLow') return a.price - b.price;
    if (sort === 'rating') return b.rating - a.rating;
    return b.students - a.students;
  });

  const SORTS: { key: Sort; label: string }[] = [
    { key: 'popular', label: 'Popular' },
    { key: 'rating', label: 'Top rated' },
    { key: 'priceLow', label: 'Price ↑' },
  ];

  return (
    <div style={{ paddingTop: 20 }}>
      <div className="hero" style={{ ...grad(meta.gradient), display: 'flex', gap: 14, alignItems: 'center' }}>
        <div className="center" style={{ width: 52, height: 52, borderRadius: 14, background: 'rgba(255,255,255,.2)', fontSize: 26 }}>{meta.icon}</div>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 900 }}>{category.title}</h1>
          <p style={{ opacity: 0.9, fontSize: 14, marginTop: 2 }}>{category.description}</p>
        </div>
      </div>

      <div className="row" style={{ justifyContent: 'space-between', margin: '16px 0' }}>
        <span className="muted" style={{ fontWeight: 700 }}>{items.length} packs</span>
        <div className="row gap8">
          {SORTS.map((s) => (
            <button key={s.key} className={`chip ${sort === s.key ? 'active' : ''}`} onClick={() => setSort(s.key)}>{s.label}</button>
          ))}
        </div>
      </div>

      {items.map((p) => (
        <ProductRow key={p.id} product={p} />
      ))}
    </div>
  );
}
